import { makeReducer } from "../../core/make-reducer";
import ViewerMethod from "../../core/ViewerMethod";
import { decodeHTML } from "../../../../../../common/utils/string";

const reducer = makeReducer(
  ViewerMethod.GET_BOOK_INFO,
  ({ preferences, ...info }) => ({
    ...info,
    features: info.features || [],
    title: decodeHTML(info.title),
  })
);
export default reducer;
